import React, { useEffect, useState } from 'react';
import {Platform, Text, View, StyleSheet,Button, Alert, Modal,FlatList, TextInput } from 'react-native'
import { useNavigation } from '@react-navigation/native';
import { MagnifyingGlassIcon as GlassIcon } from "react-native-heroicons/solid";
import { inline } from 'react-native-web/dist/cjs/exports/StyleSheet/compiler';
import ResourceButton from './ResourceButtons/ResoruceButton';
import ResourceButtonD from './ResourceButtons/ResoruceButtonDownload';


const DownloadResources = (  ) => {

    const [isLoading, setLoading] = useState(true);
    const [data, setData] = useState([]);
  
    useEffect(() => {
      fetch('https://raw.githubusercontent.com/Lozamded/NoRepo-SomeJson/main/main.json')
        .then((response) => response.json())
        .then((json) => setData(json))
        .catch((error) => console.error(error))
        .finally(() => setLoading(false));
    }, []);
  
  
    return (
      <View style={styles.mainview}>
        <Text>Versión movil: </Text>
        <Text/>
        <View style={styles.searchview}>
          <GlassIcon style={{height:30}}/>
          <TextInput style={{paddingLeft:12, marginLeft:12}}  placeholder="Curso... "/>
        </View>
        
        <Text>Version: {data["version"]} </Text>
        <Text> Mis Recursos :</Text>
        <Text/>
  
        {isLoading ? <Text>Loading...</Text> : 
          <View>
            <Text>Version: {data["version"]} </Text>
            <Text/>
            <FlatList
              data={data["situaciones"]}
              renderItem={ ({item: resource}) => (
                <ResourceButtonD
                  codigo ={resource["codigo"]}
                  nombre ={resource["nombre"]}
                  ejes = {resource["ejes"]}
                  version = {resource["version"]}
                  tags = {resource["tags"]}
                  niveles = {resource["niveles"]}
                />
              )}
            />
          </View>
        }
      </View>
    );
      
};
    
  

const styles = StyleSheet.create({

    searchview: {
    padding: 6,
    flexDirection: 'row',
    flexGrow: 1,
    backgroundColor: '#C4C4C6',
    maxWidth: 232,
    height: Platform.OS != 'web' ? 44 : 42,
    }
});

export default DownloadResources